import { AlternateEmailsAction, RECEIVE_ALTERNATE_EMAILS, REQUEST_ALTERNATE_EMAILS } from '@Actions/alternate_email';

import { IAlternateEmailModel } from '@Shared/models';

interface IAlternateEmailsState {
  loading: boolean;
  alternateEmails: IAlternateEmailModel[];
}

const defaultState: IAlternateEmailsState = {
  alternateEmails: null,
  loading: false
};

export function alternateEmails(state = defaultState, action: AlternateEmailsAction) {
  switch (action.type) {
    case REQUEST_ALTERNATE_EMAILS:
      return { loading: true, alternateEmails: null };
    case RECEIVE_ALTERNATE_EMAILS:
      return {
        loading: false,
        alternateEmails: action.emails
      };
    default:
      return state;
  }
}
